import { GenericBasketItem } from '@/types';
import { fetchProductType } from '@/utils/http/fetchProductType';
import { getParams } from '@/utils/params';
import { getContextIdAndProductTypeIdOfBasketItem } from '@/model/basket/getContextIdAndProductTypeIdOfBasketItem';
import { fetchProductTypeAction } from '@/redux/productTypes/actions/fetchProductTypeAction';
import { Thunk } from '@/redux/types';
import { getDiscountsSupported } from '../getters/getDiscountsSupported';
import { getDiscountsSupportedKey } from '../getters/getDiscountsSupportedKey';
import { DiscountsActionTypes, DiscountsSupportedAction } from '../types';

interface DiscountData {
  contextId: string;
  productTypeId: string;
  supported: boolean;
}

const isDiscountData = (data: DiscountData | null): data is DiscountData => data !== null;

export const fetchDiscountsSupported =
  (basketItems: GenericBasketItem[]): Thunk<void, DiscountsSupportedAction> =>
  async (dispatch, getState) => {
    const state = getState();
    const requestedProductTypesWithContext = new Set<string>();

    const discountData = await Promise.all(
      basketItems.map(async (basketItem) => {
        const [contextId, productTypeId] = getContextIdAndProductTypeIdOfBasketItem(basketItem);
        const key =
          contextId && productTypeId ? getDiscountsSupportedKey(contextId, productTypeId) : '';

        if (
          !contextId ||
          !productTypeId ||
          requestedProductTypesWithContext.has(key) ||
          getDiscountsSupported(state, contextId, productTypeId) !== undefined
        ) {
          return null;
        }

        requestedProductTypesWithContext.add(key);

        try {
          const productType = await (contextId === getParams().contextId
            ? dispatch(fetchProductTypeAction(productTypeId))
            : fetchProductType(productTypeId, contextId));
          return { contextId, productTypeId, supported: productType.discountSupported };
        } catch (e) {
          /* ignore */
          return null;
        }
      })
    );

    const payload = discountData.filter(isDiscountData);
    if (payload.length > 0) {
      dispatch({
        type: DiscountsActionTypes.DISCOUNTS_SUPPORTED,
        payload,
      });
    }
  };
